$(document).ready(function () {
  var time = $("div.htmcustom").attr("data-limit-display");
  var count = time * 1000;
  var pathname = document.location.pathname;
  $.each($("div.breadcrumb_border a.link-hover-line"), function(i,v) {
     let href = v.pathname;
     console.log(v);
     if(href == "/collections/high-jewelry")
     {
          $("div.free_shipping_text div.txt_div > p").remove();
          $("div.free_shipping_text div.txt_div").append("<p>Free Shipping</p>");
     }
  })
  if (pathname == "/") {
    let attr_current = $(
      "div.notification-banner.notification-banner--banner.popup.popup--bottom-left"
    ).attr("style");
    $(
      "div.notification-banner.notification-banner--banner.popup.popup--bottom-left"
    ).attr("style", attr_current + ";right: inherit; left: 1%; display:block");
    //$("div.htmcustom").addClass("htmhidden");
    setTimeout(() => {
      $(
        "div.notification-banner.notification-banner--banner.popup.popup--bottom-left"
      ).attr("style", attr_current + ";right: inherit; left: 1%; display:none");
    }, count);
    $("div.htmcustom button.link.modal-close-button.popup-close").click(
      function () {
        $(
          "div.notification-banner.notification-banner--banner.popup.popup--bottom-left"
        ).attr(
          "style",
          attr_current + ";right: inherit; left: 1%; display:none"
        );
      }
    );
  } else {
    /*setTimeout(() => {
            $("div.htmcustom").addClass("htmhidden");
        }, count);
        $("div.htmcustom button.link.modal-close-button.popup-close").click(function() {
           $("div.htmcustom").addClass("htmhidden");
        })*/
  }
  $("li.list-menu--megamenu").click(function (e) {
      e.preventDefault();
      console.log("d");
      let $this = $(this);
      let isActive = $this.hasClass("active");
  
      // Đóng tất cả menu
      $("li.list-menu--megamenu").removeClass("active");
  
      // Nếu menu hiện tại chưa active, kích hoạt nó
      if (!isActive) {
          $this.addClass("active");
      }
  
      // Đóng menu khi click ra ngoài
      $(document).on("click.closeMenu", function (event) {
          if (!$(event.target).closest("li.list-menu--megamenu").length) {
              $("li.list-menu--megamenu").removeClass("active");
              $(document).off("click.closeMenu"); // Gỡ sự kiện
          }
      });
   });

  // Handle click on mega menu items
  $("li.list-menu--megamenu > .header__menu-item").click(function (e) {
    e.stopPropagation(); // Prevent event from bubbling to document
    const $parent = $(this).closest("li.list-menu--megamenu");
    
    // Close any other open menus
    $("li.list-menu--megamenu").not($parent).removeClass("active");

    // Toggle the current menu
    $parent.toggleClass("active");
  });

  // Allow links inside the menu to work
  $("li.list-menu--megamenu a").click(function (e) {
    e.stopPropagation(); // Ensure the menu doesn't close
    // Do not prevent default to allow navigation
  });

  // Close menu if clicking outside
  $(document).click(function () {
    $("li.list-menu--megamenu").removeClass("active");
  });
});
///show socials
function togglehp() {
  $(".ico01").click(function () {
    $("div.wrapper").toggleClass("activehp");
  });
}
togglehp();
///end show socials
///remove notification
function removeNotification() {
  var pathname = document.location.pathname;
  if (pathname == "/pages/diamond-details") {
    $("div.htmcustom").addClass("htmhidden");
    let attr_current = $(
      "div.notification-banner.notification-banner--banner.popup.popup--bottom-left"
    ).attr("style");
    $(
      "div.notification-banner.notification-banner--banner.popup.popup--bottom-left"
    ).attr("style", attr_current + "; top: 10%;right: inherit; left: 2%;");
  }
}

///end remove notification
